import React from "react";

const Forbidden = () => {
  return (
    <div>
      <h1>Forbidden</h1>
      <p style={{ marginTop: "20px" }}>
        Trang mà bạn truy cập, chứa tài nguyên mà bạn không được phép truy cập
      </p>
      <p style={{ marginTop: "20px" }}>
        Vui lòng liên hệ với quản trị viên để biết thêm thông tin
      </p>
    </div>
  );
};

export default Forbidden;
